import {
  GET_PENDINGSKULOOKUP_REPORT_REQUEST,
  GET_PENDINGSKULOOKUP_REPORT_SUCCESS,
  GET_PENDINGSKULOOKUP_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";


export const getpendingskulookupnu = (token, values) => (dispatch) => {
  dispatch({ type: GET_PENDINGSKULOOKUP_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/pendingSkulookupreport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values, 
  })
    .then((response) => {
      return dispatch({
        type: GET_PENDINGSKULOOKUP_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PENDINGSKULOOKUP_REPORT_ERROR,
        payload: [],
      });
      
      
      
      
      
      
      
      
      
      
    });
};
